const SINGLE_COLUMN_POSITION = 4;

const getPromoIndex = (nbCols: number, nbItems: number): number =>
    Math.min(nbCols === 1 ? SINGLE_COLUMN_POSITION - 1 : nbCols - 1, nbItems);

export { getPromoIndex };
